<template>
    <div class="pic-frame" @click="skip">
        <img :src="currentPic" alt="">
        <img :src="loadSrc" alt="" class="hide" style="display: none">
    </div>
</template>

<script>
    export default {
        computed:{
            currentPic(){
                return this.fileName+this.current+'.png'
            }
        },
        data(){
            return{
                count:120,
                fileName:'./frames/logo0828_',
                current:'00021',
                index:21,
                timer:null,
                loadSrc:'./frames/logo0828_00021.png'
            }
        },
        mounted() {
            this.loadImg()
            document.addEventListener('click',this.skip)
            document.addEventListener('keydown',this.skip)
        },
        beforeDestroy() {
            document.removeEventListener('click',this.skip)
            document.removeEventListener('keydown',this.skip)
        },
        methods:{
            frameAnimate(){
                if(this.index<this.count){
                    this.index++
                    if(this.index<10){
                        this.current='0000'+this.index
                    }
                    else if(this.index<100){
                        this.current='000'+this.index
                    }
                    else{
                        this.current='00'+this.index
                    }
                }else{
                    clearInterval(this.timer)
                    this.$emit('animatedCallback')
                }
            },
            skip(){
                clearInterval(this.timer)
                this.$emit('animatedCallback')
            },
            loadImg(){
                for(let i=21;i<121;i++){
                    const img=new Image()
                    img.onload=()=>{
                        if(i===120){
                            this.timer=setInterval(this.frameAnimate,30)
                        }
                    }
                    if(i<10){
                        img.src='./frames/logo0828_0000'+i+'.png'
                        this.loadSrc=img.src
                    }
                    else if(i<100){
                        img.src='./frames/logo0828_000'+i+'.png'
                        this.loadSrc=img.src
                    }
                    else{
                        img.src='./frames/logo0828_00'+i+'.png'
                        this.loadSrc=img.src
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .pic-frame{
        position: fixed;
        height: 450px;
        width: 520px;
        top: 50%;
        left: 50%;
        margin: -265px 0 0 -260px;
        z-index: 10;
        img{
            display: block;
            margin: 0 auto;
            width: 470px;
            height: 364px;
        }
    }
</style>
